import { getApp, getApps, initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getFunctions } from "firebase/functions";

export const firebaseConfig = {
  apiKey: "AIzaSyBALlRvfXqe8syGka1i-1GicrUqiq6aYHs",
  authDomain: "clllimousine.firebaseapp.com",
  projectId: "clllimousine",
  storageBucket: "clllimousine.appspot.com",
  messagingSenderId: "594492515868",
  appId: "1:594492515868:web:3f5e496d3dd6520638e1d9",
};

const app = getApps().length ? getApp() : initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
const functions = getFunctions(app, "europe-west1");

export { app, auth, db, functions };
